import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TiposAgrupamentosService {

  baseUrl = environment.baseUrl;

  constructor(
    private http: HttpClient
  ) { }

  listarTiposDeAgrupamento() {
    const url = `${this.baseUrl}listarTiposDeAgrupamentos`;
    return this.http.get(url);
  }
}
